import URLS from "@/constants/api";
import { get_2 } from "./api";

export const downloadContactUsAPI = async () => {
  const response = await get_2(URLS.DOWNLOAD_CONTACTUS);
  return response;
};
